const Technology = require("../../../entities/Technology");
const {TechnologyNames, TechnologyTypes, Age}  = require("../../Constants");

class Arena extends Technology {
    constructor(age, techName, scienceCost, workerCost, militaryMultiplier, happyFaceMultiplier){
        super(
            age,
            Arena.GetType(),
            techName,
            scienceCost,
            workerCost,
            {
                playerStateAltering:
                    (playerState) => {
                        playerState.militaryCalculationDelegate.push({
                            Source: this,
                            Action: () => this.GetWorkerCount()*militaryMultiplier,
                        });
                        playerState.happyFaceCalculationDelegate.push({
                            Source: this,
                            Action: () => this.GetWorkerCount()*happyFaceMultiplier,
                        });
                    }
            }
        )
        // Happy faces per arena (worker), e.g. for Michelangelo
        this.happyFaces = happyFaceMultiplier;
    }
    static GetType = () => TechnologyTypes.Urban.Arena;
}

class BreadAndCircuses extends Arena {
    constructor(){
        super(BreadAndCircuses.GetAge(), BreadAndCircuses.GetName(), 3, 3, 1, 2)
    }

    static GetInstance = () => new BreadAndCircuses();
    static GetAge = () => Age.Age1;
    static GetName = () => TechnologyNames.Urban.BreadAndCircuses;
}

class TeamSports extends Arena {
    constructor(){
        super(TeamSports.GetAge(), TeamSports.GetName(), 5, 5, 2, 3)
    }

    static GetInstance = () => new TeamSports();
    static GetAge = () => Age.Age2;
    static GetName = () => TechnologyNames.Urban.TeamSports;
}

// (the expansion's: 4 strength per worker; the base game's: 3. See Constants/CardVersions.js)
class ProfessionalSports extends Arena {
    constructor(version){
        super(ProfessionalSports.GetAge(), ProfessionalSports.GetName(), 7, 7, version === 'expansion' ? 4 : 3, 4)
        this.version = version;
    }

    static GetInstance = (version) => new ProfessionalSports(version);
    static GetAge = () => Age.Age3;
    static GetName = () => TechnologyNames.Urban.ProfessionalSports;
}

module.exports = {
    BreadAndCircuses,
    TeamSports,
    ProfessionalSports
}